import { Component, Input, OnInit, Inject } from "@angular/core";

import { JobTitlesDataService } from "../../../core/jobtitles.dataservice";
import { CrewPermissionsService } from "../../../core/crew-permissions.service";

@Component({
    selector: "crew-person-jobtitles",
    template: require('./person.jobtitles.component.html')
})
export class PersonJobTitlesComponent implements OnInit {

    isPermissionWriteOrAdmin: boolean;

    constructor(
        @Inject(JobTitlesDataService.Id) private jobtitleDataService: JobTitlesDataService,
        private crewPermissionsService: CrewPermissionsService) { }

    jobTitles: Nema.Crew.Model.JobType[];

    @Input()
    person: Nema.Crew.Model.Person;

    ngOnInit() {
        this.crewPermissionsService.isPermissionWriteOrAdmin().subscribe(value => this.isPermissionWriteOrAdmin = value);
        
        this.jobtitleDataService
            .getAll()
            .then(res => {
                this.jobTitles = res;

                (<any>this.person.PersonJobs).load();
            });
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/resources/persons/jobtitles/person.jobtitles.component.ts